import React from 'react';
import OrderBookInfo from '../../../components/chancemng/obtainorder/OrderBookInfo';

const OrderBookInfoContainer = ({ orderInfo, chance }) => {
  return <OrderBookInfo orderInfo={orderInfo} chance={chance} />;
};

export default OrderBookInfoContainer;
